<template>
  <div class=“user”>
    <div class="common-search-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline" style="flex-wrap: wrap">
        <el-form-item label="订单号">
          <el-input v-model="searchForm.order_no" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.sign_str_status">
            <el-option v-for="item in option" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="terminateSearch">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size="small" icon="el-icon-refresh" @click="terminateRefresh">刷新</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-divider style="margin:0"></el-divider>
    <el-table size="small" border class="table" :data="tableData" style="width: 100%"
      @selection-change="handleSelectionChange" default-expand-all ref="table" row-key="order_no">
      <el-table-column prop="order_no" label="订单号"></el-table-column>
      <el-table-column prop="username" label="用户名"></el-table-column>
      <el-table-column prop="state_text" label="订单状态">
        <!-- <template  slot-scope="scope" ></template> -->
      </el-table-column>
      <el-table-column label="签约状态">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.sign_str_status == 'TERMINATED'">解约</el-tag>
          <el-tag size="mini" v-if="scope.row.sign_str_status == 'SIGNED'">签约中</el-tag>
          <el-tag size="mini" v-if="scope.row.sign_str_status == 'APPLY_TERMINATE'">申请解约中</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="danger" v-if="scope.row.sign_str_status == 'SIGNED'"
            @click="noDeduction(scope.row)">
            代扣解约
          </el-button>
          <div v-if="scope.row.sign_str_status == 'APPLY_TERMINATE'">
            <el-button type="primary" size="mini" @click="Terminate(scope.row, 1)">同意解约</el-button>
            <el-button type="primary" size="mini" @click="Terminate(scope.row, 0)">拒绝解约</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="curPage" :page-sizes="[10, 20, 50, 100]" :page-size="10"
        layout="total, prev,sizes ,pager, next, jumper" :total="totalDataNumber"></el-pagination>
    </div>
  </div>
</template>

<script>
import OrderApi from '../../../api/order';
export default {
  data() {
    return {
      searchForm: {
        order_no: '',
        sign_str_status: 'all',
        page: 1,
        list_rows: 10,
      },
      loading: false,
      option: [
        {
          label: '全部',
          value: 'all'
        },
        {
          label: '解约',
          value: "TERMINATED"
        },
        {
          label: '签约中',
          value: 'SIGNED'
        },
        {
          label: '申请解约中',
          value: 'APPLY_TERMINATE'
        }
      ],
      tableData: []
    }
  },
  mounted() {
    this.getTerminateList()
  },
  methods: {
    Terminate(row, status) {
      let self = this
      OrderApi.auditCancelWithholding({
        order_id: row.order_id,
        status: status
      }, true).then(data => {
        if (data.code == 1 && status == 1) {
          self.$message({
            type: 'success',
            message: '解约成功'
          })
        } else if (data.code == 1 && status == 0) {
          self.$message({
            type: 'success',
            message: '拒绝解约成功'
          })
        }
        self.getData()
      })
    },
    noDeduction(e) {
      let self = this
      self.$confirm('是否确认代扣解约？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        OrderApi.cancelSign({
          order_no: e.order_no
        }, true).then(data => {
          if (res.code == 1) {
            self.$message({
              type: 'success',
              message: res.msg
            })
          }
        })
      })
    },
    terminateSearch() {
      this.getTerminateList()
    },
    terminateRefresh() {
      let self = this;
      this.searchForm = {
        order_no: '',
        sign_str_status: 'all',
        page: 1,
        list_rows: 10,
      }
      self.getTerminateList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.searchForm.page = val;
      self.getTerminateList();
    },
    handleSizeChange(val) {
      let self = this;
      this.searchForm.page = 1;
      this.searchForm.list_rows = val;
      this.getTerminateList();
    },
    getTerminateList() {
      let self = this
      let params = self.searchForm
      OrderApi.terminateORder(
        params
      ).then(res => {
        if (res.code == 1) {
          self.tableData = res.data.data
          console.log(self.tableData, 'self.tableData')
          self.totalDataNumber = res.data.total
        }
      })
    },
    handleSelectionChange() {

    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/order/terminate/index.vue